import context from './context'

export default {
  props: {
    // whether to show popup
    show: Boolean,
    // z-index
    zIndex: [String, Number],
    // return the mount node for popup
    container: [String, Function],
    // whether to lazy render
    lazyRender: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      inited: this.show
    }
  },

  computed: {
    shouldRender() {
      return this.inited || !this.lazyRender
    }
  },

  watch: {
    show(val) {
      this.inited = this.inited || this.show
      this[val ? 'open' : 'close']()
    },

    container() {
      this.move()
    }
  },

  mounted() {
    if (this.container) {
      this.move()
    }
    if (this.show) {
      this.open()
    }
  },
  activated() {
    /* istanbul ignore next */
    if (this.show) {
      this.open()
    }
  },

  beforeDestroy() {
    this.close()

    // if (this.container) {
    //   this.$parent?.$el?.appendChild(this.$el)
    // }
  },

  deactivated() {
    /* istanbul ignore next */
    this.close()
  },

  methods: {
    open() {
      /* istanbul ignore next */
      if (this.$isServer || this.opened) {
        return
      }

      // cover default zIndex
      if (this.zIndex !== undefined) {
        context.zIndex = this.zIndex
      }

      this.opened = true
      this.renderZIndex()
    },

    close() {
      if (!this.opened) {
        return
      }

      this.opened = false
    },

    move() {
      let container

      const { container: getContainer } = this
      if (getContainer) {
        container = typeof getContainer === 'string' ? document.querySelector(getContainer) : getContainer()
      } else if (this.$parent) {
        container = this.$parent.$el
      }

      if (container) {
        container.appendChild(this.$el)
      }
    },

    renderZIndex() {
      this.$nextTick(() => {
        this.$el.style.zIndex = context.zIndex++
      })
    }
  }
}
